import React from "react";
import { Grid } from "@material-ui/core";
import { EmptyStateWrapper, HeaderWrapper, InfoWrapper } from "./styles";
var EmptyState = function (_a) {
    var header = _a.header, icon = _a.icon, description = _a.description, button = _a.button;
    return (React.createElement(EmptyStateWrapper, null,
        React.createElement(Grid, { xs: 12 },
            React.createElement(HeaderWrapper, null, header)),
        React.createElement(Grid, { xs: 12 },
            React.createElement(InfoWrapper, null,
                React.createElement("div", { className: "item" },
                    " ",
                    icon),
                React.createElement("div", { className: "item" },
                    " ",
                    description),
                React.createElement("div", { className: "item" },
                    " ",
                    button)))));
};
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map